import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import './TextInputStyle.css';

const MoneyInput = props => {
    const { def, data, onChange, state, warning } = props;
    const baseClassName = 'basicinput_de ant-input';
    const err = warning !== undefined && warning !== '';
    const className = err ? baseClassName + ' ant-input-status-error' : baseClassName;

    //The only problem with this component is you can't blank it out.
    const checkCurrency = (value) => {
        if (isNaN(value) && value !== '' && value !== undefined) return;
        onChange(def.dataKey, value);
    }

    const myPrecision = def.precision || 2;

    return <CurrencyInput
        className={className}
        allowDecimals={true}
        value={data}
        onValueChange={(value, name) => checkCurrency(value)}
        decimalsLimit={myPrecision}
        prefix='$'
        disableAbbreviations
        disabled={state.readonly === 1}
        maxLength={def.maxLength}
        data-input={'moneyinput_de'}
    />


}

export default MoneyInput;
